<action-title-header
  [title]="'ProjectsList.title' | translate"
  [buttonText]="'ProjectsList.addProject' | translate"
  [loading]="loadingAddProject()"
  (onAction)="addProject()"
  [doubleHeightOnMobile]="true"
  [stickyWithSideNavigation]="true"
  [permissionDecorator]="{ group: PermissionsGroups.PROJECTS, action: 'ADD' }"
>
  <list-search />

  <div class="projects-list__tabs">
    <button-group-v2 [config]="buttonGroupConfig" class="w-100 w-sm-auto" />
  </div>

  <list-filters-btn-v2 [filters]="ProjectsFiltersComponent" />
</action-title-header>

<side-navigation-view
  [updateLocationParam]="true"
  [config]="configSideNavigation"
  (onTabClick)="onTabClick($event)"
  #sideNavigationViewComponent
>
  <main class="projects-list">
    <div class="container-fluid--30 projects-list__content">
      <ng-select
        #selectStage
        ngSelectExtension
        class="select select-default w-100 projects-list__select-tabs select-with-title"
        [dropdownPosition]="'bottom'"
        [items]="stages"
        [clearable]="false"
        [searchable]="false"
        bindLabel="text"
        bindValue="id"
        [placeholder]="'ProjectsList.stagesTitle' | translate"
        (change)="onTabClick($event, true)"
        [tabIndex]="-1"
      />

      <app-list
        *ngIf="inited"
        [config]="config"
        [emptyTemplate]="emptyTemplate"
        [searchName]="'ProjectsList.searchProject' | translate"
        [selected]="selected"
        [filters]="ProjectsFiltersComponent"
        (activate)="activate($event)"
        [showToggleMenu]="showToggleMenu.bind(this)"
        [headerHidden]="true"
        #list
      />
    </div>
  </main>
</side-navigation-view>

<ng-template #emptyTemplate>
  <div class="d-flex flex-column align-items-center mt-4 empty">
    <img
      draggable="false"
      src="/assets/img/Project.svg"
      [alt]="'ProjectsList.noProjects' | translate"
      class="mb-4 mt-4"
    />
    <div class="mt-2 mb-2">{{ 'ProjectsList.noProjects' | translate }}</div>
    <app-button
      [permission]="{
        group: PermissionsGroups.PROJECTS,
        action: 'ADD'
      }"
      (onClick)="addProject()"
      [config]="{
        type: ButtonTypes.NEW_PRIMARY_BLUE,
        text: 'ProjectsList.addProject' | translate,
        size: ButtonSize.LARGE,
        prependSrc: './assets/img/ic-plus-add.svg'
      }"
    />
  </div>
</ng-template>

<project-client-cell #projectClientCell />
<project-name-cell #projectNameCell />
<project-property-type-cell #projectPropertyTypeCell />
<project-stage-cell #projectStageCellComponent />
<project-responsible-client-cell #projectResponsibleClientCell />
<project-responsible-company-cell #projectResponsibleCompanyCell />
<project-name-header-cell #projectNameHeaderCell />
<project-lose-cell #projectLoseCell />
<project-origin-cell #projectOriginCell />
<project-address-cell #projectAddressCell />
